import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  TextField,
  IconButton,
  Collapse,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  Typography,
  Paper,
} from '@mui/material';
import {
  quickSearchChitalishta,
  selectQuickSearchResults,
  selectQuickSearchLoading,
  selectIsHomepageSearchVisible,
  toggleHomepageSearch,
  clearQuickSearchResults,
  setMapSelectedChitalishte,
} from '../../store/slices/chitalishtaSlice';
import CloseIcon from '@mui/icons-material/Close';

const Search = () => {
  const dispatch = useDispatch();
  const isVisible = useSelector(selectIsHomepageSearchVisible);
  const searchResults = useSelector(selectQuickSearchResults);
  const isLoading = useSelector(selectQuickSearchLoading);
  const [query, setQuery] = useState('');

  useEffect(() => {
    if (query.length > 2) {
      dispatch(quickSearchChitalishta(query));
    } else {
      dispatch(clearQuickSearchResults());
    }
  }, [query, dispatch]);

  const handleToggle = () => {
    dispatch(toggleHomepageSearch());
    if (isVisible) {
      setQuery('');
      dispatch(clearQuickSearchResults());
      // Removed dispatch(setMapSelectedChitalishte(null)); to keep selection when closing search
    }
  };

  const handleSearchChange = (event) => {
    setQuery(event.target.value);
  };

  const handleResultClick = (chitalishte) => {
    // // console.log('Selected chitalishte from search, passing directly to map:', chitalishte);
    // Подаваме обекта от търсенето директно към картата
    dispatch(setMapSelectedChitalishte(chitalishte));
    handleToggle(); // Затваряме прозореца за търсене
  };

  return (
    <Collapse in={isVisible}>
      <Paper
        elevation={4}
        sx={{
          position: 'absolute',
          top: '80px',
          left: '60px',
          zIndex: 999,
          p: 2,
          width: '300px',
          bgcolor: 'background.paper',
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Търсене</Typography>
          <IconButton onClick={handleToggle}>
            <CloseIcon />
          </IconButton>
        </Box>
        <TextField
          fullWidth
          variant="outlined"
          label="Търсене по име, община, населено място..."
          value={query}
          onChange={handleSearchChange}
          margin="normal"
        />
        {isLoading && <CircularProgress />}
        {searchResults.length > 0 && (
          <List>
            {searchResults.map((chitalishte) => (
              <ListItem
                button
                key={chitalishte.id}
                onClick={() => handleResultClick(chitalishte)}
              >
                <ListItemText
                  primary={chitalishte.name}
                  secondary={`${chitalishte.town}, ${chitalishte.municipality}`}
                />
              </ListItem>
            ))}
          </List>
        )}
      </Paper>
    </Collapse>
  );
};

export default Search;
